import { Resource } from '@redge-media/fo-js-sdk';
import ChannelsCollection from './channels-collection';
import Channel from './channel';

const Channels = Resource.extend({
  endpoint: 'products/lives',
  collectionClass: ChannelsCollection,
  recordClass: Channel,

  constructor: function Channels(attrs = [], opts = {}) {
    Resource.call(this, attrs, opts);
  },
});

export default Channels;
